export { default } from './svg/virtual-embed.svg';
